import { format } from "date-fns";
import { Button } from "../../../../components/ui/button";

export function getUserColumns({ onSelectUser, onUserActions }) {
  return [
    {
      accessorKey: "photoURL",
      header: "Photo",
      enableSorting: false,
      cell: ({ row }) => {
        return row.original.photoURL ? (
          <div className="rounded-full overflow-hidden flex items-center justify-center w-[48px] h-[48px]">
            <img
              src={row.original.photoURL}
              width={48}
              height={48}
              alt="user"
              className="object-cover"
            />
          </div>
        ) : (
          <img
            src="/avatar.svg"
            width={48}
            height={48}
            alt="default avatar"
            className="object-cover rounded-full"
          />
        );
      },
    },
    {
      accessorKey: "customUrl",
      header: "Username",
      enableSorting: false,
    },
    {
      accessorKey: "firstName",
      header: "Prénom",
      enableSorting: false,
    },
    {
      accessorKey: "lastName",
      header: "Nom",
      enableSorting: false,
    },
    {
      accessorKey: "email",
      header: "Email",
      enableSorting: false,
    },
    {
      accessorKey: "createdAt",
      header: "Date création",
      cell: ({ row }) => {
        const date = row.original.createdAt;
        return date ? format(new Date(date), "dd/MM/yyyy") : "";
      },
      enableSorting: false,
    },
    {
      accessorKey: "whiteLabel",
      header: "Whitelabel",
      enableSorting: false,
    },
    {
      id: "actions",
      header: "Actions",
      enableSorting: false,
      cell: ({ row }) => (
        <Button
          size="sm"
          variant="default"
          onClick={(e) => {
            e.stopPropagation();
            onSelectUser(row.original);
            onUserActions && onUserActions();
          }}
        >
          Actions
        </Button>
      ),
    },
  ];
}
